import { replaceInArrayByIndex } from '../replaceInArrayByIndex'
import { addEntity } from './addEntity'
import { ID, Optional } from './types'

export function replaceEntity<T extends Object>(
	entities: Optional<T[]>,
	entityId: ID,
	entityForReplacement: T,
	getEntityId = (entity: T) => {
		if ('id' in entity) {
			return entity.id
		}
		throw new Error('Entity does not have an id')
	},
) {
	const _entities = entities ?? []
	const entityIndex = _entities.findIndex((entity) => getEntityId(entity) === entityId)
	if (entityIndex === -1) {
		return addEntity(_entities, entityForReplacement)
	}

	return replaceInArrayByIndex(_entities, entityIndex, entityForReplacement)
}
